import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

// Sends booking confirmation (customer) + internal notification via callable
export async function sendBookingEmail(bookingDataForEmail) {
  const callable = httpsCallable(functions, 'sendBookingEmailCallable');
  const result = await callable({ booking: bookingDataForEmail });
  return result.data;
}

// Sends a customer support request (non-admin) to internal inbox
export async function sendSupportRequest(data) {
  const callable = httpsCallable(functions, 'sendSupportRequestCallable');
  const result = await callable(data);
  return result.data;
}


